import { Request } from "../Request";

interface LoginData {
  password: string;
  email: string;
}

export function login(data: LoginData) {
  return Request.post("/login", { data, noAuth: true });
}

export function check() {
  return Request.get("/check", {});
}
